import { useState } from "react";
import "../styles/insertionsort.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import CodeBoard from "./CodeBoard";

const InsertionSort = () => {
  let arr = [9, 8, 7, 6, 5, 4, 3, 2, 1];

  let [data, setData] = useState([arr]);
  let [highlight, sethighlight] = useState([]);
  let [sorted, setSorted] = useState([]);
  let [speed, setSpeed] = useState(500);
  let [disable, setDisable] = useState(false);

  const handleInsertionSort = async (e) => {
    e.preventDefault();
    let n = arr.length;
    let i = 0;
    let j = 1;
    let highlight = [];
    let sorted = [];

    const sort = () => {
      setDisable(true);
      if (i < n) {
        if (j > 0 && arr[j - 1] > arr[j]) {
          let temp = arr[j];
          arr[j] = arr[j - 1];
          arr[j - 1] = temp;
          j--;
        } else {
          i++;
          j = i + 1;
          sorted.push(i - 1);
        }
        highlight = [j - 1, j];
        setData([arr]);
        sethighlight(highlight);
        setSorted(sorted);
        if (i < n) {
          setTimeout(sort, speed);
        } else {
          console.log(arr);
          setData([arr]);
          setDisable(false);
        }
      }
    };
    setTimeout(sort, speed);
  };

  const handleReset = (e) => {
    e.preventDefault();
    sethighlight([]);
    setSorted([]);
    setData([arr]);
    setSpeed(500);
  };

  const handleSlow = () => {
    setSpeed(speed + 100);
  };

  const handleFast = () => {
    setSpeed(speed - 100);
  };

  return (
    <div className="insertionsort">
      <div className="insertionsort_navbar">
        <h1 className="sort_header_text">Insertion Sort</h1>
      </div>
      <div className="insertionsort_container">
        {data[0].map((num, index) => (
          <span
            className={`nums ${highlight.includes(index) ? "highlight" : ""} ${
              sorted.includes(index) ? "sorted" : ""
            }`}
            key={num}
          >
            {num}
          </span>
        ))}
      </div>
      <div className="complexity_container">
        <span className="complexity_text">Time Complexity - O(N<span className="sup">2</span>)</span>
      </div>
      <div className="complexity_container">
        <span className="complexity_text">Space Complexity - O(<span>1</span>)</span>
      </div>
      <div className="insertionsort_footer">
        <button
          className="btn btn-primary"
          onClick={handleSlow}
          disabled={disable}
        >
          <FontAwesomeIcon icon={faMinus} />
        </button>
        <span className="btn btn-light" style={{ cursor: "pointer" }}>
          Speed : {speed}
        </span>
        <button
          className="btn btn-primary"
          onClick={handleFast}
          disabled={disable}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
        <button
          className="btn btn-success"
          onClick={handleInsertionSort}
          disabled={disable}
        >
          Sort
        </button>
        <button
          className="btn btn-danger"
          onClick={handleReset}
          disabled={disable}
        >
          Reset
        </button>
      </div>
      <CodeBoard code="insertionsort" />
    </div>
  );
};

export default InsertionSort;
